import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Header, Button, Icon } from 'semantic-ui-react';
import i18next from 'i18next';

import './Confirmation.scss';

const Confirmation = ({ open, onConfirm, onCancel }) => {
    return (
        <Modal open={open} basic size='small'>
            <Header icon='warning circle' content={i18next.t('order.payAttentionClearOrder')} />
            <Modal.Content>
                <p>
                    {i18next.t('order.confirmOrderAbort')}
                </p>
            </Modal.Content>
            <Modal.Actions className="pi actions">
                <Button color='red' onClick={onCancel}>
                    <Icon name='remove' /> {i18next.t('general.no')}
                </Button>
                <Button color='green' onClick={onConfirm}>
                    <Icon name='checkmark' /> {i18next.t('general.yes')}
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

Confirmation.propTypes = {
    open: PropTypes.bool,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func
};

export default Confirmation;
